import { useLocaleSettings } from '@/hooks/useLocaleSettings';
import { hasRideSupply } from '@/utility/rideSupply';

// Ride car-rental cross-sell links only render on country editions where Ride
// actually has supply. Everywhere else the Guest lands on an empty results page
// on a second brand, which can never produce a booking.
//
// This keys off the site edition the Guest is browsing (router.locale is derived
// from the domain — outdoorsy.ca -> CA), not their IP or browser language. That
// keeps it SSR-safe, so a link never paints and then disappears, and a Guest in
// Toronto on outdoorsy.com still sees the cross-sell.
//
// Surfaces that carry a location of their own should gate on that location
// instead — see getRideCarBannerVisibility, which uses the booking's pickup.
export const useShowRideLinks = (): boolean => {
  const { country } = useLocaleSettings();

  return hasRideSupply(country);
};
